import {Box, Grid, Typography} from "@mui/material";
import Countdown from "react-countdown";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


export const useCuentaRegresiva = ({fecha = new Date().setTime(23)}) => {
    const {sCell} = useResponsive()


    const Reloj = () => {

        const CajaNumero = ({nombre, numero}) => {
            return (
                <Box sx={{backgroundColor: '#fff', borderRadius: 2, p: 1}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontSize: 18,
                                fontWeight: 600,
                                color: theme.palette.primary.main
                            }}>{numero}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontSize: 14,
                                fontWeight: 400,
                            }}>{nombre}</Typography>
                        </Grid>

                    </Grid>
                </Box>
            )
        }

        const renderer = ({days, hours, minutes, seconds, completed}) => {

            // return <span>{`${days}d-${hours}h-${minutes}m-${seconds}s`}</span>;
            return (

                <Grid
                    container
                    justifyContent={sCell ? 'center' : 'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >


                    <CajaNumero nombre={'Dias'} numero={days}/>

                    <CajaNumero nombre={'Hrs'} numero={hours}/>

                    <CajaNumero nombre={'Mins'} numero={minutes}/>

                    <CajaNumero nombre={'Secs'} numero={seconds}/>

                </Grid>

            )

        };

        return (


            <Countdown
                daysInHours={true}
                date={fecha}
                renderer={renderer}
            />


        )
    }

    return {
        Reloj
    }

}